"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const TableauWorksheetEvent_1 = require("./TableauWorksheetEvent");
class CustomMarkContextMenuEvent extends TableauWorksheetEvent_1.TableauWorksheetEvent {
    constructor(worksheet, contextMenuId) {
        super(api_external_contract_js_1.EmbeddingTableauEventType.CustomMarkContextMenuEvent, worksheet);
        this._contextMenuId = contextMenuId;
    }
    getContextMenuId() {
        return this._contextMenuId;
    }
    getSelectedMarksAsync() {
        return this.worksheet.getSelectedMarksAsync();
    }
}
exports.CustomMarkContextMenuEvent = CustomMarkContextMenuEvent;
//# sourceMappingURL=CustomMarkContextMenuEvent.js.map